<template>
  <ProtocolRulesTwo></ProtocolRulesTwo>
</template>

<script>
import ProtocolRulesTwo from "@/components/ProtocolRulesTwo.vue";
export default {
  components: {
    ProtocolRulesTwo,
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/systemManagement/privacyAgreement/privacyAgreement.vue